var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "assistant-permission-dialog",
      attrs: {
        visible: _vm.assistantVisible,
        title: "项目权限",
        width: "560px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.assistantVisible = $event
        },
        close: _vm.resetForm,
      },
    },
    [
      _c("permission-config-panel", {
        attrs: { "show-description": true, "label-width": "110px" },
        model: {
          value: _vm.permissionData,
          callback: function ($$v) {
            _vm.permissionData = $$v
          },
          expression: "permissionData",
        },
      }),
      _c(
        "span",
        {
          staticClass: "assistant-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "cancel-btn",
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  _vm.assistantVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }